import { memo } from "react";

import { SvgIconProps, SvgIcon } from "@material-ui/core";

import svgSet from "./svgSet";

interface Props extends SvgIconProps {
  name: string;
}

const Icon = ({ name, ...rest }: Props): JSX.Element => (
  <SvgIcon viewBox="0 0 16 16" {...rest}>
    {svgSet[name]}
  </SvgIcon>
);

export default memo(Icon);
